export default theme => ({
    wrapper: {
        borderBottom: 'none !important',
        paddingBottom: '10px'
    },
    radioLabel: {
        fontWeight: 700
    }
});
